import { render, staticRenderFns } from "./CBNReport.vue?vue&type=template&id=fc0a7be2&"
import script from "./CBNReport.vue?vue&type=script&lang=js&"
export * from "./CBNReport.vue?vue&type=script&lang=js&"
import style0 from "./CBNReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports